import { render, staticRenderFns } from "./WeekSelect.vue?vue&type=template&id=e8d4db0c&"
import script from "./WeekSelect.vue?vue&type=script&lang=js&"
export * from "./WeekSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports